module.exports = __webpack_public_path__ + "img/seat.0f37f62e.jpg";